import React, { FC } from 'react';
import MaterialUILink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { BpDesignSystem } from '../../types';

export type LinkProps = BpDesignSystem.PropsWithChildren<MuiLinkProps> & {};

export const Link: FC<LinkProps> = ({ dataTest, underline = 'hover', ...rest }) => (
  <MaterialUILink color="primary" data-test={dataTest} underline={underline} href="#" {...rest} />
);
